<template>
  <div class="interviewArrangement">
    <van-row class="arrangeNum">
      <van-col span="6">
        <div
          class="titleItem"
          :class="{ check: param.queryType == 5 }"
          @click="handleCheck(5)"
        >
          <p>待面试</p>
          <p>{{ statisticalList[4].value }}</p>
        </div>
      </van-col>
      <van-col span="6">
        <div
          class="titleItem"
          :class="{ check: param.queryType == 1 }"
          @click="handleCheck(1)"
        >
          <p>今日面试</p>
          <p>{{ statisticalList[0].value }}</p>
        </div>
      </van-col>
      <van-col span="6">
        <div
          class="titleItem"
          :class="{ check: param.queryType == 3 }"
          @click="handleCheck(3)"
        >
          <p>待反馈</p>
          <p>{{ statisticalList[2].value }}</p>
        </div>
      </van-col>
      <van-col span="6">
        <div
          class="titleItem"
          :class="{ check: param.queryType == 4 }"
          @click="handleCheck(4)"
        >
          <p>全部面试</p>
          <p>{{ statisticalList[3].value }}</p>
        </div>
      </van-col>
    </van-row>
    <div class="list">
      <!-- 搜索 -->
      <van-row class="search-focus">
        <div class="search">
          <van-search
            v-model="param.candidateMobile"
            maxlength="11"
            type="tel"
            oninput="value=value.replace(/[^0-9]/g,'')"
            clearable
            :placeholder="placeholderSearch[param.queryType]"
            @input="handleBlur"
          />
        </div>
        <van-button
          @click="interViewStyle"
          :class="param.interviewTypeName ? 'search-icon' : 'search-button'"
          :icon="param.interviewTypeName ? 'cross' : 'arrow-down'"
          icon-position="right"
          round
          plain
          size="mini"
          :text="param.interviewTypeName ? param.interviewTypeName : '面试方式'"
        />
        <van-button
          @click="interViewTime"
          :class="param.startTime ? 'search-icon' : 'search-button'"
          :icon="param.startTime ? 'cross' : 'arrow-down'"
          icon-position="right"
          v-if="param.queryType !== 5 && param.queryType !== 1"
          round
          plain
          size="mini"
          :text="
            param.startTime ? `${param.startTime}-${param.endTime}` : '面试时间'
          "
        />
      </van-row>
      <van-list
        v-if="listToday.length > 0"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div
          v-for="(item, index) in listToday"
          :key="index"
          slot="default"
          @click="resumeClick(item)"
          class="itemCont"
        >
          <p class="cell1">
            <span>{{ item.name || '-' }}</span>
            <span>{{ item.genderStr || '-' }}</span>
            <span>{{ item.eduLevelStr || '-' }}</span>

            <span
              class="user_register"
              :style="doClaimLoding ? 'pointer-events: none;opacity: 0.7;' : ''"
              v-if="item.claimFlag == 1"
              @click.stop="claimUser(item)"
              >认领</span
            >
            <span
              class="user_register"
              @click.stop="interViewResult(item)"
              v-if="item.claimFlag != 1 && item.interviewResult == null"
              >反馈结果</span
            >
            <span
              class="user_register"
              v-if="item.interviewType === 2"
              @click.stop="interViewVideo(item)"
              >视频面试</span
            >
          </p>
          <p class="cell2">
            <span id="copy-mobile" @click.stop="copyMobile(item.mobile)">{{
              item.mobile || '-'
            }}</span>
          </p>
          <p class="cell3">
            <span>应聘职位：{{ item.postName || '-' }}</span>
          </p>
          <p class="cell3">
            <span>面试时间：{{ item.interviewTime || '-' }}</span>
          </p>
          <p class="cell3" v-if="item.interviewResult">
            <span
              >面试结果：{{ item.interviewResultStr || '' }}
              {{ item.interviewEvaluate || '' }}</span
            >
          </p>
        </div>
      </van-list>
      <!-- 定制无数据展示文案 -->
      <div
        class="noData"
        v-if="
          listToday.length === 0 &&
          [1, 5].includes(param.queryType) &&
          param.candidateMobile &&
          showBg
        "
      >
        <div class="noDataImg"></div>
        <p>未搜索到候选人</p>
        <p>请确认候选人手机号</p>
      </div>
      <div
        class="noData"
        v-if="
          listToday.length === 0 &&
          [1, 5].includes(param.queryType) &&
          showBg &&
          !param.candidateMobile
        "
      >
        <div class="noDataImg"></div>
        <p>
          {{
            param.queryType === 1
              ? '今日暂未面试任何候选人'
              : '暂无任何待面试的候选人'
          }}
        </p>
        <p>搜索候选人手机号进行认领，认领后反馈面试结果</p>
      </div>
      <div
        class="noData"
        v-if="
          listToday.length === 0 && ![1, 5].includes(param.queryType) && showBg
        "
      >
        <div class="noDataImg"></div>
        <p>暂无面试候选人</p>
      </div>
    </div>
    <interViewResult ref="inter_view_result" @callback="interCallback" />
    <interViewVideo ref="inter_view_video" />
    <resume ref="resume" />
    <van-popup
      v-model="interviewTypeVisible"
      position="bottom"
      class="common-popup"
      get-container="body"
    >
      <van-picker
        show-toolbar
        :columns="interViewWayOptions"
        @cancel="interviewTypeVisible = false"
        @confirm="handlePickerConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
import Vue from 'vue';
import {
  pageList,
  interviewStatistical,
  doClaim,
  queryInterview,
} from '../../api/interview';
import {
  Search,
  Row,
  Col,
  List,
  CellGroup,
  Popup,
  Toast,
  Field,
  Dialog,
  Button,
  Picker,
} from 'vant';
import interViewResult from './components/interViewResult';
import interViewVideo from './components/interViewVideo';
import resume from './components/resume';
import * as dd from 'dingtalk-jsapi';

Vue.use(Search)
  .use(Row)
  .use(Col)
  .use(List)
  .use(CellGroup)
  .use(Popup)
  .use(Toast)
  .use(Field)
  .use(Dialog)
  .use(Button)
  .use(Picker);

const interViewWayOptions = [
  {
    key: '视频面试',
    text: '视频面试',
    value: 2,
  },
  {
    key: '线下面试',
    text: '线下面试',
    value: 0,
  },
];
const placeholderSearch = [
  '',
  '请输入待认领的候选人手机号',
  '',
  '请输入候选人手机号',
  '请输入候选人手机号',
  '请输入待认领的候选人手机号',
];
const statisticalList = [
  { value: 0 },
  { value: 0 },
  { value: 0 },
  { value: 0 },
  { value: 0 },
];
export default {
  data() {
    return {
      showBg: false,
      listToday: [],
      loading: false,
      finished: false,
      interviewTypeVisible: false,
      interViewWayOptions,
      param: {
        candidateMobile: '',
        pageSize: 5,
        currentPage: 1,
        queryType: 5,
        interviewType: '',
        interviewTypeName: '',
        startTime: '',
        endTime: '',
      },
      placeholderSearch,
      statisticalList,
      doClaimLoding: false,
      // 时间组件默认值
      demo: {
        defautStart: '',
        defautEnd: '',
      },
    };
  },

  components: {
    interViewResult,
    interViewVideo,
    resume,
  },

  mounted() {
    if (this.$route.query.queryType) {
      this.param.queryType = this.$route.query.queryType;
    }
    this.getStactics();
    this.getList();
  },

  methods: {
    // 搜索
    handleBlur() {
      if (this.param.candidateMobile && this.param.candidateMobile.length < 11) return;
      this.search();
    },

    search() {
      this.finished = false;
      this.param.pageSize = 10;
      this.param.currentPage = 1;
      this.listToday = [];
      this.getList();
    },

    interViewTime(e) {
      if (this.param.startTime && e.srcElement.className.includes('van-icon')) {
        this.param.startTime = '';
        this.param.endTime = '';
        this.search();
        return;
      }
      if (dd.env.platform === 'notInDingTalk') return Toast('请在钉钉内部打开');
      dd.biz.calendar.chooseInterval({
        defaultStart: this.demo.defautStart
          ? this.demo.defautStart
          : Date.now(),
        defaultEnd: this.demo.defautEnd ? this.demo.defautEnd : Date.now(),
        onSuccess: (res) => {
          this.demo.defautStart = res.start;
          this.demo.defautEnd = res.end;
          this.param.startTime = this.$utils.formatShortDate(res.start);
          this.param.endTime = this.$utils.formatShortDate(res.end);
          this.search();
        },
        onFail: (err) => {},
      });
    },

    interViewStyle(e) {
      if (
        this.param.interviewTypeName &&
        e.srcElement.className.includes('van-icon')
      ) {
        this.param.interviewType = '';
        this.param.interviewTypeName = '';
        this.search();
        return;
      }
      this.interviewTypeVisible = true;
    },

    handlePickerConfirm(item) {
      this.param.interviewType = item.value;
      this.param.interviewTypeName = item.text;
      this.search();
      this.interviewTypeVisible = false;
    },

    handleCheck(keyStr) {
      this.param.candidateMobile = '';
      this.param.startTime = '';
      this.param.endTime = '';
      this.param.interviewType = '';
      this.param.interviewTypeName = '';
      this.param.queryType = keyStr;
      this.search();
      this.getStactics();
    },

    getList() {
      Toast.loading({
        duration: 5000,
        forbidClick: true,
        overlay: false,
        message: '加载中...',
      });
      this.showBg = false;
      const params = { ...this.param };
      if (params.interviewTypeName) delete params.interviewTypeName;
      if (params.candidateMobile && params.candidateMobile.length !== 11) delete this.params.candidateMobile;
      if (
        params.candidateMobile &&
        (params.queryType == 1 || params.queryType == 5)
      ) {
        // 今日面试待面试手机号搜索逻辑
        params.queryType = 4;
        if (params.startTime) {
          params.startTime = `${params.startTime} 00:00:00`;
          params.endTime = `${params.endTime} 23:59:59`;
        }
        queryInterview(params)
          .then((res) => {
            this.listToday = res.data;
            if (
              res.pageCount == params.currentPage ||
              res.data.length < 10 ||
              res.data.length == 0
            ) this.finished = true;
            this.$nextTick((i) => {
              this.showBg = true;
            });
          })
          .catch((error) => {
            this.showBg = true;
            Toast.clear();
            Toast('系统错误 请稍后再试');
          })
          .finally(() => {
            Toast.clear();
          });
      } else {
        pageList(params)
          .then((res) => {
            if (res) {
              this.listToday = this.listToday.concat(res.data);
              if (
                res.pageCount == params.currentPage ||
                res.data.length < 10 ||
                res.data.length == 0
              ) this.finished = true;
              this.$nextTick((i) => {
                this.showBg = true;
              });
            } else {
              this.finished = true;
            }
          })
          .catch((error) => {
            this.finished = true;
            this.showBg = true;
          })
          .finally(() => {
            Toast.clear();
          });
      }
    },

    onLoad() {
      setTimeout(async () => {
        this.param.currentPage++;
        this.loading = true;
        await this.getList();
        this.loading = false;
      }, 1000);
    },

    getStactics() {
      interviewStatistical()
        .then((res) => {
          if (res) this.statisticalList = res;
        })
        .catch((error) => {});
    },

    copyMobile(mobile) {
      if (!mobile) return;
      try {
        const range = document.createRange();
        range.selectNode(document.querySelector('#copy-mobile'));
        const selection = window.getSelection();
        if (selection.rangeCount > 0) selection.removeAllRanges();
        selection.addRange(range);
        document.execCommand('copy');
        Toast('复制成功');
      } catch (err) {
        Toast('复制失败');
      }
      window.getSelection().removeAllRanges(); // 移除选中的元素
    },

    // 认领
    claimUser(val) {
      Dialog.confirm({
        title: '确认认领吗',
        confirmButtonText: '认领',
        cancelButtonText: '取消认领',
      })
        .then(() => {
          this.doClaimLoding = true;
          doClaim({ interviewId: val.id })
            .then((res) => {
              this.doClaimLoding = false;
              Toast.success('认领成功');
              this.search();
              this.getStactics();
            })
            .catch((err) => {
              Toast(err || '提交失败 请稍后再试');
            });
        })
        .catch(() => {});
    },

    // 查看简历
    resumeClick(item) {
      this.$refs.resume.init(item);
    },

    // 面试结果
    interViewResult(val) {
      this.$refs.inter_view_result.init(val);
    },

    // 面试结果 callback
    interCallback() {
      this.search();
      this.getStactics();
    },

    // 视屏面试
    interViewVideo(item) {
      this.$refs.inter_view_video.init(item);
    },
  },
};
</script>
<style lang="scss">
.interviewArrangement {
  color: #333;
  font-size: 32px;
  background-color: rgba(248, 248, 248, 1);
  .search-focus {
    padding: 20px 50px;
    background: #fff;
    .search {
      border-radius: 34px;
      overflow: hidden;
      .van-search {
        display: flex;
        height: 38px;
        background: #f8f8f8;
        justify-content: center;
        align-items: center;
      }
      .van-field__control {
        font-size: 16px;
        font-weight: 800;
        padding-left: 10px;
      }
      .van-field__control::placeholder {
        font-weight: 400;
        font-size: 14px;
      }
      .van-icon-search::before {
        color: #999;
        font-size: 18px;
      }
    }
    .search-button {
      background: #f2f2f2;
      margin: 20px 20px 0 0;
      padding: 0 15px 0 20px;
    }
    .search-icon {
      background: #f2f2f2;
      margin: 20px 20px 0 0;
      padding: 0 15px 0 20px;
      .van-icon {
        padding-left: 5px;
      }
    }
  }
  .arrangeNum {
    color: #000;
    background-color: rgba(248, 248, 248, 1);
    padding: 30px;
    margin-left: 10px;
    .titleItem {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 16px;
      background-color: #ffffff;
      flex-direction: column;
      height: 140px;
      width: 156px;
      font-size: 30px;
      box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.1);
      p:first-child {
        margin-bottom: 10px;
      }
      p:last-child {
        color: #f1524a;
        font-weight: 500;
      }
      &.check {
        background: rgba(255, 255, 255, 1)
          linear-gradient(
            270deg,
            rgba(255, 135, 28, 1) 0%,
            rgba(239, 76, 79, 1) 100%
          );
        color: #ffffff;
        p:last-child {
          color: #ffffff;
        }
      }
    }
  }
  .list {
    background: #f8f8f8;
    .noData {
      background: #ffffff;
      padding-top: 150px;
      line-height: 50px;
      .noDataImg {
        height: 202px;
        margin-bottom: 20px;
        background: url(https://web-data.zmlearn.com/image/kED1eTLQU5Z2mBDFeRKgU7/no_arrange.png) no-repeat center;
      }
      p {
        text-align: center;
        font-size: 26px;
        color: rgba(153, 153, 153, 1);
      }
    }
    .itemCont {
      background-color: #ffffff;
      font-size: 28px;
      padding: 45px;
      margin-bottom: 15px;
      box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.05);
      .cell1 {
        span:nth-child(1) {
          font-size: 36px;
          color: #000;
          font-weight: 500;
        }
        margin-bottom: 30px;
        span {
          margin-right: 20px;
        }
      }
      .user_register {
        display: block;
        float: right;
        border: 2px solid #f1524a;
        border-radius: 36px;
        padding: 5px 20px;
        min-width: 95px;
        margin-right: 20px !important;
        color: #f1524a;
        font-size: 24px;
        text-align: center;
      }
      .cell2 {
        display: flex;
        span {
          padding-right: 20px;
        }
      }
      .cell3 {
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
  .van-list {
    background: #fff;
  }
}
.common-popup {
  .van-picker__confirm {
    font-size: 17px;
    color: #1989fa !important;
  }
  .van-picker__cancel {
    font-size: 17px;
  }
  .van-picker-column__item--selected {
    font-weight: 500;
  }
  .van-hairline-unset--top-bottom {
    border-top: 0.5px solid #c0c0c0;
    border-bottom: 0.5px solid #c0c0c0;
  }
}
</style>
